// The blog's words (ADR-029 point 3). A post's own words live in its file.
export const BLOG_WORDS_EN = {
  footerLabel: "Blog",
  feedTitle: "Blog feed",
  twinTitle: "This post in markdown",
  eyebrow: "Blog",
  heading: "Finding leads on Instagram",
  lede: "How to read an account's followers and following, and what to do with a public contact.",
  seoTitle: "Blog: finding leads on Instagram",
  description:
    "Guides on finding leads on Instagram: what counts as a lead, where the contact comes from, and what you may do with it.",
  keyphrase: "finding leads on Instagram",
  all: "All",
  categoriesLabel: "Filter posts by category",
  empty: "No posts in this language yet.",
  featured: "Featured",
  listTitle: "Posts",
  categories: { guides: "Guides", "how-to": "How-to", product: "Product", data: "Data" },
  breadcrumbLabel: "Breadcrumb",
  byline: "By",
  published: "Published",
  updated: "Updated",
  faqTitle: "Questions",
  sourcesTitle: "Sources",
  relatedTitle: "Related posts",
  pagesTitle: "Put it to work",
};
